import { message } from 'antd';
import status from './status';
import i18n from '@/locales/i18n';
import Cookies from 'js-cookie';
import api_domain_config from '../views/account/constants/common';
import store from '../views/account/redux/store';

const request = (url, options) => {
  let controller = new AbortController(); //可用于中止fetch请求
  let HTTPUrl = url;
  let HTTPOptions = { method: 'GET', signal: controller.signal };
  // Consolidation request
  Object.assign(HTTPOptions, options);

  //GET Method: query characters are attached to url behind;
  if (
    (HTTPOptions.method === 'GET' && options.data) ||
    HTTPOptions.method === 'HEAD'
  ) {
    let searchStr = '';
    if (options.data instanceof Object) {
      for (let i in options.data) {
        searchStr += i + '=' + options.data[i];
      }
    }
    HTTPUrl = url + '?' + searchStr;
  }

  console.log(HTTPOptions);
  return new Promise((resolve, reject) => {
    fetch(HTTPUrl, HTTPOptions)
      .then((res) => {
        return res.json();
      })
      .then((res) => {
        if (res && res.code) {
          if (res.code === 401) {
            // start 因购买页不需要跳转登录，增加此段逻辑
            let isPurchasePage = window.location.hash.match(/\purchase/);
            let isGetPurchase = HTTPUrl.includes('check-out');
            // 购买页调接口返回401的时候不需要跳转登录
            // 但是如果是调了购买接口，即点击了“购买按钮”，就需要跳转
            let linkQuery =
              isPurchasePage && isGetPurchase ? `?to=purchase` : '';
            if (window.location.href.indexOf('track[type]') >= 0) {
              const urlParam = getUrlParam(window.location.href);
              linkQuery += `?track[type]=${urlParam['track[type]']}&track[sid]=${urlParam['track[sid]']}&track[func]=${urlParam['track[func]']}&track[reason]=${urlParam['track[reason]']}&track[host]=${urlParam['track[host]']}&track[platform]=${urlParam['track[platform]']}&track[ab]=${urlParam['track[ab]']}&track[channel]=${urlParam['track[channel]']}&track[discount]=${urlParam['track[discount]']}`;
            }
            if (!isPurchasePage || (isPurchasePage && isGetPurchase)) {
              window.location.href = `${window.location.origin}/tools/v2/account.html#/login${linkQuery}`;
            }
            // end
            Cookies.remove('authorization');
            store.dispatch({
              type: 'AUTHORIZATION',
              authorization: null,
            });
          }
          if (res.code !== 200) {
            if (status[res.code]) {
              message.warn(status[res.code]);
            } else {
              message.warn(i18n.t('common:serverErrorTips'));
            }
          }
          resolve(res);
          //为了兼容 feedback 的服务器返回格式
        } else if (res && res.status) {
          if (res.status === 200) {
            resolve(res);
          } else {
            if (status[res.status]) {
              message.warn(status[res.status]);
            } else {
              message.warn(i18n.t('common:serverErrorTips'));
            }
            resolve(res);
          }
        } else {
          message.warn(i18n.t('common:serverErrorTips'));
          resolve(res);
        }
      })
      .catch((error) => {
        if (error.name === 'AbortError') {
          console.log('Fetch was aborted');
        } else {
          message.warn(i18n.t('common:serverErrorTips'));
          reject(error);
        }
      });
  });
};

export default request;

function getUrlParam(url) {
  // 通过 ? 分割获取后面的参数字符串
  let urlStr = url.split('?')[1];
  // 创建空对象存储参数
  let obj = {};
  // 再通过 & 将每一个参数单独分割出来
  let paramsArr = urlStr.split('&');
  for (let i = 0, len = paramsArr.length; i < len; i++) {
    // 再通过 = 将每一个参数分割为 key:value 的形式
    let arr = paramsArr[i].split('=');
    obj[arr[0]] = arr[1];
  }
  return obj;
}
